module.exports = __webpack_public_path__ + "img/homePageActivityPopBg.f74573d0.png";